module.exports = __webpack_public_path__ + "img/tabbed-vehicle-rows-content-ford.ea93962d.jpg";